<template>
  <DolphinSelector
    :options="options"
    v-model="status"
    :class="$style.statusSelector"
    v-slot="slotProps"
    small
  >
    <ChatRoomStatusCircle :status="typedStatus(slotProps.value)" />
  </DolphinSelector>
</template>

<script lang="ts" setup>
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import ChatRoomStatusCircle from '@/components/molecules/ChatRoomStatusCircle.vue'
import type { Option, OptionValueType } from '@/types/app'
import { computed } from 'vue'
import type { ChatRoomStatus } from '@/types/schema.generated'
import {
  allChatRoomStatuses,
  chatRoomStatusString,
} from '@/models/chatRoom/chatRoomStatus'

type ChatListStatusOption = Option<ChatRoomStatus>

const props = defineProps<{
  selectedStatus: ChatRoomStatus
}>()

const emit = defineEmits<{
  (event: 'changeStatus', value: ChatRoomStatus): void
}>()

const options: ChatListStatusOption[] = allChatRoomStatuses.map(s => ({
  value: s,
  text: chatRoomStatusString[s],
}))

const typedStatus = (value: OptionValueType): ChatRoomStatus => {
  return value as ChatRoomStatus
}

const status = computed({
  get: () => {
    return props.selectedStatus
  },
  set: value => {
    emit('changeStatus', value)
  },
})
</script>

<style lang="scss" module>
.statusSelector {
  width: 100%;
  flex: 0 0 auto;
}
</style>
